module.exports = __webpack_public_path__ + "img/Slide11.aaad6315.png";